"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGeo = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useGeo = function () {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GEO_DATA,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    };
};
exports.useGeo = useGeo;
